import PropTypes from 'prop-types';
import { AdvancedCombobox } from '@evertrue/et-components';

const ContactField = ({
  onChange,
  onBlur,
  name,
  value,
  contactOptions = [],
  required = true,
  field,
  meta,
  helpers,
}) => {
  // Contact Options could be nested
  const isGrouped =
    Array.isArray(contactOptions) &&
    contactOptions.length > 0 &&
    Array.isArray(contactOptions[0].items) &&
    contactOptions[0].items.length > 0;

  const getValue = () => {
    if (isGrouped) {
      return contactOptions[0].items.find((item) => item.value === value);
    } else {
      return contactOptions.find((option) => option.value === value);
    }
  };

  return (
    <AdvancedCombobox
      label="Contact Field"
      value={getValue()}
      options={contactOptions}
      grouped={Boolean(isGrouped)}
      searchable={true}
      placeholder="Select constituent..."
      onChange={(selected) => {
        helpers.setValue(selected?.value);
      }}
      onClose={() => {
        helpers.setTouched(true, false);
      }}
    />
  );
};

ContactField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // it'll only ever be a string if it's an empty string
  contactOptions: PropTypes.array,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default ContactField;
